import type { BadgeVariant as CKBadgeVariant } from '@property.com.au/ui-kit';

export type BadgeVariant =
  | 'BLUE'
  | 'CALLOUT'
  | 'GREEN'
  | 'GREY'
  | 'HIDDEN'
  | 'ORANGE'
  | 'PURPLE'
  | 'RED'
  | 'WHITE'
  | 'YELLOW';

export const mapBadgeVariant = (variant: BadgeVariant): CKBadgeVariant => {
  switch (variant) {
    case 'GREEN':
      return 'green';
    case 'GREY':
      return 'grey';
    case 'YELLOW':
      return 'yellow';
    case 'BLUE':
      return 'blue';
    case 'RED':
      return 'red';
    case 'ORANGE':
      return 'orange';
    case 'PURPLE':
      return 'purple';
    case 'HIDDEN':
      return 'hidden';
    case 'CALLOUT':
      return 'callout';
    case 'WHITE':
      return 'white';
    default:
      return 'grey';
  }
};
